<template>
  <div class="directory">
    <div class="top wbg" v-if='$common.AUTH("court:list")'>
      <div class="group">
        <a-form-model ref="ruleForm" :model="form">
          <div class="label">
            法院名称：
            <a-input v-model="form.title" placeholder='请输入法院名称' style="width: 167px;"> </a-input>
          </div>
          <div class="btns">
            <a-button type="primary" icon="search" @click="query(1)">查询</a-button>
            <a-button @click="reset" style="min-width: 64px;border-color:none;">重置</a-button>
            <a-button v-if="$common.AUTH('court:add')" type="primary" ghost icon="plus" @click="linkTo()">新增</a-button>
          </div>
        </a-form-model>
      </div>
      <div class="tcity">
        <div class="cell fir">
          <div class="h2">省份首字母筛选</div>
          <div class="ul">
            <a href="javascript:void(0);" v-for="i in engList" @click="setKey(i)" :class="{'act':form.province_first_word==i}">{{i}}</a>
          </div>
        </div>
        <div class="cell" v-if="form.province_first_word">
          <a href="javascript:void(0);" v-for="i in proList" @click="setPro(i)" :class="{'act':form.province_id==i.id}">{{i.full_name}}</a>
        </div>

        <div class="cell" v-if="form.province_id">
          <a href="javascript:void(0);" v-for="i in cityList" @click="setCity(i)" :class="{'act':form.city_id==i.id}">{{i.full_name}}</a>

        </div>
      </div>
    </div>

    <div class="tcon wbg">
      <div class="tableList" v-if='$common.AUTH("court:list")'>
        <a-table rowKey="id" :columns="columns" :customRow="dbclick" :data-source="data" :pagination="page" @change="query">
          <div slot="province" slot-scope="text, record">
            <span>{{record.province + ' ' + record.city + ' ' + record.area + ' ' + record.addr}}</span>
          </div>
          <div slot="zxj_province" slot-scope="text, record">
            <span v-if='record.zxj_province'>{{record.zxj_province + ' ' + record.zxj_city + ' ' + record.zxj_area + ' ' + record.zxj_addr}}</span>
            <span v-else>/</span>
          </div>
          <div slot="alist" slot-scope="text, record">
            <!-- <template v-if="$common.AUTH('court:add')">
              <router-link :to="{ path: '/directory/edit', query: {id: record.id,t:1} }" target='_blank'>查看</router-link>
            </template> -->
            <a-popconfirm title="确认删除此条数据吗?" ok-text="确定" cancel-text="取消" @confirm='deleteConfirm(record.id)' v-if='$store.state.user.id==1'>
              <a href='javascript:void(0);'>删除</a>
            </a-popconfirm>
            <template v-if='$common.AUTH("court:editWithAudit")'>
              <span class="line" v-if="$store.state.user.id==1"></span>
              <router-link :to="{ path: '/directory/edit', query: {id: record.id} }" target='_blank'>修改</router-link>
            </template>
            <template v-if="$common.AUTH('court:list')">
              <span class="line"></span>
              <router-link :to="{ path: '/directory/edit', query: {id: record.id,t:1} }" target='_blank'>查看</router-link>
            </template>
          </div>
        </a-table>
      </div>
      <div class="nqx" v-else>您没有该页面的访问权限，请联系管理员开通。</div>
    </div>
  </div>
</template>
<script>
import { getDirectory, directoryDel } from "@/server/directory"
import City from '@/assets/js/city.json'
import { listbycourt } from "../../server/statis";
const columns = [
  {
    title: '名称',
    key: 'title',
    dataIndex: 'title',
    width: "30%"
  },
  {
    title: '立案庭地址',
    key: 'province',
    dataIndex: 'province',
    scopedSlots: { customRender: 'province' },
    width: "30%"
  },
  {
    title: '执行局地址',
    key: 'zxj_province',
    dataIndex: 'zxj_province',
    scopedSlots: { customRender: 'zxj_province' },
    width: "30%"
  },
  // {
  //   title: '联系人姓名',
  //   key: 'uname',
  //   dataIndex: 'uname',
  //   align: 'center'
  // },
  // {
  //   title: '联系电话',
  //   key: 'phone',
  //   dataIndex: 'phone',
  //   align: 'center'
  // },
  {
    title: '操作',
    key: 'alist',
    dataIndex: 'alist',
    scopedSlots: { customRender: 'alist' },
    width: "20%"
  },
];
export default {
  data() {
    return {
      engList: ['A', 'B', 'C', 'F', 'G', 'H', 'J', "L", 'N', "Q", "S", "T", "X", "Y", "Z"],
      selectedRowKeys: [],
      form: {
        province_first_word: '',
        province_id: '',
        city_id: '',
        title: ''
      },
      modalVisible: false,
      columns,
      data: [],
      directoryForm: {
        id: '',
        status: 1
      },
      page: {
        current: 1,
        pageSize: 10,
        showQuickJumper: true,
        showLessItems: true,
        // showQuickJumper: true,
        // showSizeChanger: true,
        total: 0,
        showTotal(total) {
          return `小计 ${total} `
        }
      },
      groupData: this.$store.state.user ? this.$store.state.user.link_group : []
    }
  },
  created() {
    this.query()
  },
  computed: {
    proList() {
      if (this.form.province_first_word) {
        return City.filter(ele => {
          return ele.first_char == this.form.province_first_word
        })
      }
    },
    cityList() {
      if (this.form.province_first_word && this.form.province_id) {
        const list = this.proList.filter(ele => {
          return this.form.province_id == ele.id
        })
        if (list.length > 0) {
          return list[0].more
        } else {
          return []
        }
      } else {
        return []
      }
    }
  },
  mounted() {
    let _this = this
    document.onkeydown = function (e) {
      // console.log(e)
      if (e.keyCode == 13) {
        _this.query(1)
      }
    }
  },
  methods: {
    setCity(item) {
      this.form.city_id = item.id == this.form.city_id ? '' : item.id
      this.query(1)
    },
    setPro(item) {
      this.form.province_id = item.id == this.form.province_id ? '' : item.id
      this.form.city_id = '';
      this.query(1)
    },
    setKey(item) {
      this.form.province_first_word = item == this.form.province_first_word ? '' : item
      this.form.province_id = '';
      this.form.city_id = '';
      this.query(1)
    },
    dbclick(record) {
      return {
        on: { // 事件
          dblclick: (event) => {
            this.$router.push({ path: '/directory/edit', query: { id: record.id } })

          },
        }
      }
    },
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys
    },
    linkTo() {
      this.$router.push({ path: '/directory/add' });
    },
    query(val) {
      if (val) {
        if (typeof val === 'object') {
          this.page.current = val.current
          this.page.pageSize = val.pageSize
        } else {
          this.page.current = 1
        }
      }
      let obj = Object.assign({
        page: this.page.current,
        limit: this.page.pageSize
      }, this.form);
      getDirectory(obj).then((res) => {
        this.data = res.list
        this.page.total = res.count
      })
    },
    reset(){
      this.page.pageSize = 10
      this.page.current = 1
      this.form.title = ''
      this.query()
    },
    deleteConfirm(id) {
      this.$modal.confirm({
        content: '确认删除这条记录？',
        onOk: () => {
          directoryDel({ id: id }).then((res) => {
            this.$message.success({ content: '删除成功' });
            this.query()
          })
        }
      });
    }
  }
}
</script>
<style lang="less" scoped>
.directory {
  @import url("@/assets/css/topForm");
  .top {
    .tcity {
      background: #f6f8fc;
      margin-top: 16px;
      .cell {
        // min-height: 42px;
        padding: 0 20px;
        border-bottom: 1px solid #efefef;
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        &:nth-last-child(1) {
          border-bottom: 0 none;
        }
        .h2 {
          font-size: 16px;
          font-weight: 500;
          color: #a2a3a5;
          line-height: 22px;
          margin-right: 56px;
        }
        a {
          margin-right: 20px;
          font-size: 14px;
          color: #66707c;
          line-height: 42px;
        }
        .act {
          color: #1d8bfe;
        }
      }
      .fir {
        border-right: 1px solid #efefef;
        padding-right: 0;
        .ul {
          flex: 6;
          display: flex;
          border-top: 1px solid #efefef;

          a {
            line-height: 42px;
            border-left: 1px solid #efefef;
            display: block;
            flex: 1;
            text-align: center;
            color: #0e2949;
            margin-right: 0;
            font-size: 16px;
            font-weight: bold;
          }
          .act {
            background: #1d8bfe;
            color: #fff;
          }
        }
      }
    }
    .group {
      display: flex;
      align-items: center;
    }
    .to {
      display: inline-block;
      width: 20px;
      height: 1px;
      margin: 0 10px;
      background-color: #dbdcde;
      vertical-align: middle;
    }
    // form {
    //   width: 100%;
    // }
    // .label {
    //   display: inline-block;
    //   margin-right: 60px;
    //   font-size: 14px;
    //   color: #0e2949;
    // }
    // .btns {
    //   float: left;
    //   button {
    //     margin-left: 20px;
    //     min-width: 90px;
    //   }
    // }
  }
}
// .ant-btn {
//   border-color: #1d8bfe;
//   color: #1d8bfe;
// }
// .ant-btn-primary {
//   color: #ffffff;
//   border-color: #1d8bfe;
//   background-color: #1d8bfe;
// }
.tcon {
  padding: 0 20px;
  min-height: 760px;
  .line {
    display: inline-block;
    width: 1px;
    height: 14px;
    background-color: #dbdcde;
    margin: 0 10px;
    vertical-align: middle;
  }
}
.modal-footer {
  text-align: center;
  .cancel {
    background-color: #b2c9e1;
    border-color: #b2c9e1;
    margin-left: 30px;
  }
}
</style>
